import React from "react";
import { Outlet } from "react-router-dom";
import AdminLayout from "../Layout/AdminLayout";

/**
 * Layout shell for Admin. Auth is enforced by AuthenticatedRoute; RBAC by AuthorizedRoute.
 */
const AdminRoute = () => (
	<AdminLayout>
		<Outlet />
	</AdminLayout>
);

export default AdminRoute;
